import { render, staticRenderFns } from "./TokenSentCard.vue?vue&type=template&id=cd59b968&scoped=true"
import script from "./TokenSentCard.vue?vue&type=script&lang=js"
export * from "./TokenSentCard.vue?vue&type=script&lang=js"
import style0 from "./TokenSentCard.vue?vue&type=style&index=0&id=cd59b968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd59b968",
  null
  
)

export default component.exports